import React, { useState } from 'react';
import useAuth from '../hooks/useAuth';
import {
  TextField,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

function InviteUsersForm() {
  const [emails, setEmails] = useState('');
  const { getToken } = useAuth();

  const handleSubmit = async () => {
    const emailList = emails.split(',').map(e => e.trim());
    let url = `${process.env.REACT_APP_URL}/api/users/invite`;
    const token = await getToken();

    const headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${token}`);
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ emails: emailList }),
      headers
    });
    
    const data = await response.json();

    if (data.failed > 0 && data.invited === 0) {
      alert('Invitations failed to send');
    } else if (data.failed > 0 && data.invited > 0) {
      alert('Some invitations failed');
    } else if (data.failed === 0 && data.invited > 0) {
      alert('Invitations sent');
    } else {
      alert('No invitations were sent');
    }
  };

  return (
    <Grid container justifyContent="center" mt={4} spacing={2}>
      <Grid item xs={12} md={6}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Send Email Invites
              </Typography>
              <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <TextField
                  label="Emails"
                  multiline
                  minRows={3}
                  placeholder="Enter emails, comma separated"
                  value={emails}
                  onChange={(e) => setEmails(e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                  Send Invites
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Grid>
    </Grid>
  );
}

export default InviteUsersForm;